module.exports = __webpack_public_path__ + "static/media/GH.9607dddd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GH.svg
// module id = 260
// module chunks = 0